import { axiosInstance } from "../../../config/api/Axios";

export const getUsersApi = async (params) =>
    axiosInstance.get("/admin/users", { params: { ...params, [params.direction]: params.sort } });
export const getUsersWithoutOrganizations = async () => axiosInstance.get("/admin/users-without-organization");
export const createAndInviteUserApi = async (userData) => axiosInstance.post("/admin/users", userData);
export const updateUserApi = async (id, userData) => axiosInstance.put(`/admin/users/${id}`, userData);
export const reinviteUserApi = async (id) => axiosInstance.patch(`/admin/users/${id}/re-invite`);
export const deleteUserApi = async (id) => axiosInstance.delete(`/admin/users/${id}`);
